import commentTextareas from './comment-textareas';

const fn = {
  classCommentHide: 'card__comments--hide',
  classCommentOptionsLinkOpen: 'card__comments__options__link--open',
  init: () => {
    const commentsOptions = document.querySelectorAll('.js-comment-toggle');

    if (!commentsOptions) {
      return;
    }

    [].forEach.call(commentsOptions, (commentsOption) => {
      commentsOption.addEventListener('click', (e) => {
        const messageId = commentsOption.getAttribute('data-comments-message-target');
        const commentItems = document.querySelector(`[data-comments-message-id="${messageId}"]`);

        fn.toggleCommentOptionsLink(commentsOption);
        fn.toggleComments(messageId, commentItems, commentItems.classList.contains(fn.classCommentHide) ? 'show' : 'hide');

        commentTextareas.init();

        const commentTextarea = document.querySelector(`[data-comment-message-id="${messageId}"]`);
        commentTextarea.focus();

        e.preventDefault();
      });
    });
  },
  toggleComments(messageId, commentItems, state) {
    if (state === 'show') {
      commentItems.classList.remove(fn.classCommentHide);
    } else {
      commentItems.classList.add(fn.classCommentHide);
    }

    app.msnry.inst.layout();
  },
  toggleCommentOptionsLink(commentsOption) {
    if (commentsOption.classList.contains(fn.classCommentOptionsLinkOpen)) {
      commentsOption.classList.remove(fn.classCommentOptionsLinkOpen);
    } else {
      commentsOption.classList.add(fn.classCommentOptionsLinkOpen);
    }
  },
};

export default fn;
